<template>
  <div class="loader-ring" v-if="load"></div>
  <img
    v-else-if="img"
    :src="`data:image/jpg;base64,${img}`"
    style="
      margin: 0 auto;
      width: 200px;
      height: auto;
      display: block;
    "
  />
</template>

<script>
import iconv from "iconv-lite";
import { readRosbagIpfs } from "@/utils/utils";

export default {
  props: ["liability", "hash"],
  data() {
    return {
      load: true,
      img: null,
    };
  },
  created() {
    this.rosbagObjective(this.hash);
  },
  methods: {
    rosbagObjective(hash) {
      let img = null;
      readRosbagIpfs(
        hash,
        (bag) => {
          if (bag.message.data === "") {
            return;
          }
          img = iconv.decode(Buffer.from(bag.message.data, "ascii"), "utf-8");
        },
        {
          topics: [
            "/liability/eth_" +
              this.$robonomics.web3.utils.toChecksumAddress(this.liability) +
              "/qr",
          ],
        }
      ).then(() => {
        this.img = img;
        this.load = false;
      });
    },
  },
};
</script>
